import { AgTechVerticalPopUpMenu, AgTechVerticalPopUpMenuSection } from '@agtech/web/components/Menus/AgTechVerticalPopUpMenu';
import { SaleInvoiceModifier } from '@sales/data/sales/InvoiceModifiers/SaleInvoiceModifierData';
import React from 'react'
import SaleInvoiceModifierDialog from '../../dialogs/SaleInvoiceModifierDialog';
import { SaleInvoiceModifierRemovalButton } from '../buttons/SaleInvoiceModifierButtons';

export type SaleInvoiceModifierActionMenuProps = {
    InvoiceModifier: SaleInvoiceModifier
};

const SaleInvoiceModifierActionMenu = (props: SaleInvoiceModifierActionMenuProps) => {
    return (
        <AgTechVerticalPopUpMenu>
            <AgTechVerticalPopUpMenuSection header="Charges and discounts">
                <SaleInvoiceModifierDialog.Button InvoiceModifier={props.InvoiceModifier} text='Update' />
                <SaleInvoiceModifierRemovalButton InvoiceModifier={props.InvoiceModifier} />
            </AgTechVerticalPopUpMenuSection>
        </AgTechVerticalPopUpMenu>
    )
};

export default SaleInvoiceModifierActionMenu;